type NewPage = {
  titulo?: string
  size?: string
  category?: string
  categoryId?: string
  brandId?: string
  brandName?: string
}

const setFormatPathName = (category: string) => {
  let formatPathName = category.toLocaleLowerCase()
  if (formatPathName === 'industrial / camiones') {
    formatPathName = 'industrial'
  }

  return formatPathName
}

export const createNewPage = (dataSearch: NewPage) => {
  const params = new URLSearchParams()

  let formatPathName = dataSearch.category
    ? setFormatPathName(dataSearch.category)
    : 'all'

  Object.keys(dataSearch).forEach((key) => {
    const value: string = dataSearch[key as keyof typeof dataSearch] || ''
    params.set(`${key}`, value.toString())
  })

  return `/neumaticos/${formatPathName}?${params.toString()}`
} //createPageUrl(currentPage - 1)
